import { render } from "./Rule.vue?vue&type=template&id=e43b1934&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"

import "./Rule.vue?vue&type=style&index=0&id=e43b1934&scoped=true&lang=css"
import "./Rule.vue?vue&type=style&index=1&id=e43b1934&lang=css"
script.render = render
script.__scopeId = "data-v-e43b1934"

export default script